module.exports = __webpack_public_path__ + "img/img9.a36fc6a1.svg";